import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs, updateSiteConfiguration } from 'actions/Site'
import { fetchProfileList, fetchProfileSummary } from 'actions/UpdateProfile'
import UpdateDataView from 'components/pages/updateData/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchProfileList: bindActionCreators(fetchProfileList, dispatch),
  fetchProfileSummary: bindActionCreators(fetchProfileSummary, dispatch),
})

const emptySummary = { inquiry: 0, approved: 0, rejected: 0 }

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  // stateSearch mirrors the URL query: page, search, status, date_from, date_to
  withState('stateSearch', 'setStateSearch', () => qs.parse(window.location.search)),
  withState('list', 'setList', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withState('summary', 'setSummary', {
    data: emptySummary,
    isFetching: true,
  }),
  withHandlers({
    getList: props => (params) => {
      const { setList } = props
      setList(prev => ({ ...prev, isFetching: true }))
      props.fetchProfileList(params)
        .then((result) => {
          setList({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch(() => {
          setList({
            data: [],
            meta: {},
            isFetching: false,
          })
        })
    },
    getSummary: props => () => {
      const { setSummary } = props
      props.fetchProfileSummary()
        .then((data) => {
          setSummary({ data: { ...emptySummary, ...data }, isFetching: false })
        })
        .catch(() => {
          setSummary({ data: emptySummary, isFetching: false })
        })
    },
  }),
  withHandlers({
    onLoad: props => (nextState) => {
      const state = nextState || props.stateSearch
      const payload = {
        page: state.page,
        query: state.search || '',
        status: state.status || '',
        date_from: state.date_from || '',
        date_to: state.date_to || '',
        limit: 10,
      }
      const cleaned = pickBy(payload, identity)
      window.history.replaceState(null, undefined, `?${qs.stringify(pickBy(state, identity))}`)
      props.getList(`?${qs.stringify(cleaned)}`)
    },
  }),
  withHandlers({
    // filter inputs only update state; "Cari" / status card applies them
    handleChangeSearch: props => (e) => {
      props.setStateSearch({ ...props.stateSearch, search: e.target.value })
    },
    handleChangeStatus: props => (val) => {
      props.setStateSearch({ ...props.stateSearch, status: val })
    },
    handleChangeDate: props => (dates) => {
      const [from, to] = dates || []
      props.setStateSearch({
        ...props.stateSearch,
        date_from: from ? from.format('YYYY-MM-DD') : '',
        date_to: to ? to.format('YYYY-MM-DD') : '',
      })
    },
    handleSearch: props => () => {
      const next = { ...props.stateSearch, page: '' }
      props.setStateSearch(next)
      props.onLoad(next)
    },
    handleReset: props => () => {
      const next = {}
      props.setStateSearch(next)
      props.onLoad(next)
    },
    // click on summary card = quick status filter
    handleFilterStatus: props => (status) => {
      const next = { ...props.stateSearch, status, page: '' }
      props.setStateSearch(next)
      props.onLoad(next)
    },
    handlePage: props => (val) => {
      const next = { ...props.stateSearch, page: val }
      props.setStateSearch(next)
      props.onLoad(next)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Pengkinian Data'])
      this.props.updateSiteConfigs({
        titlePage: 'Pengkinian Data',
        activePage: 'update-data',
        activeSubPage: 'update-data',
      })
      this.props.getSummary()
      this.props.onLoad()
    },
  }),
)(UpdateDataView)
